import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const Messages = React.lazy(() => import('../pages/Messages'));
const ArchivedChats = React.lazy(() => import('../pages/ArchivedChats'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const chatRoutes = (
  <>
    <Route path="/messages" element={<SuspenseWrapper><Messages /></SuspenseWrapper>} />
    <Route path="/archived-chats" element={<SuspenseWrapper><ArchivedChats /></SuspenseWrapper>} />
  </>
);
